var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Switch, Route } from 'react-router';
import * as queryString from 'query-string';
import * as cx from 'classnames';
import { MEDIA_QUERIES } from 'shared/style';
import { isClient } from 'shared/logic';
import Board from './Board';
import Gallery from './Gallery';
import Post from './Post';
import PostWriter from './PostWriter';
import PostModifier from './PostModifier';
import Title from 'components/shared/Title';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
export var BoardType;
(function (BoardType) {
    BoardType["Board"] = "Board";
    BoardType["Gallery"] = "Gallery";
})(BoardType || (BoardType = {}));
export var ALL_CATEGORY = '전체';
var categoryColor = '#444';
var categoryHoverColor = '#aaa';
var activeColor = '#36c';
var RootDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  \n  > .area {\n    > .title {\n      ", " {\n        max-width: 1200px;\n      }\n      ", " {\n        width: 100%;\n      }\n      padding: 50px 20px 0;\n      margin: 0 auto;\n    }\n\n    > .category-wrap {\n      max-width: 1200px;\n      margin: 20px auto;\n      padding: 20px;\n\n      > .categories {\n        max-width: 1180px;\n        padding: 20px;\n        overflow: auto;\n        background-color: #f9f9f9;\n\n        > .category {\n          height: 50px;\n          float: left;\n          cursor: pointer;\n          \n          ", " {\n            width: 20%;\n          }\n\n          ", " {\n            width: 25%;\n          }\n\n          ", " {\n            width: 50%;\n          }\n\n          &:hover {\n            > .category-name {\n              color: ", ";\n            }\n\n            > .underbar {\n              background-color: ", ";\n            }\n          }\n\n          > .category-name {\n            font-size: 14px;\n            height: 40px;\n            line-height: 40px;\n            color: ", ";\n            transition: color 0.4s;\n          }\n\n          > .underbar {\n            width: 15px;\n            height: 2px;\n            background-color: ", ";\n            transition: background-color 0.4s;\n          }\n        }\n\n        > .active {    \n          > .category-name {\n            color: ", " !important;\n          }\n        \n          > .underbar {\n            background-color: ", " !important;\n          }\n        }\n      }\n    }\n\n    > .board {\n      padding: 20px 0;\n      ", " {\n        min-height: 600px;\n      }\n    }\n  }\n"], ["\n  width: 100%;\n  \n  > .area {\n    > .title {\n      ", " {\n        max-width: 1200px;\n      }\n      ", " {\n        width: 100%;\n      }\n      padding: 50px 20px 0;\n      margin: 0 auto;\n    }\n\n    > .category-wrap {\n      max-width: 1200px;\n      margin: 20px auto;\n      padding: 20px;\n\n      > .categories {\n        max-width: 1180px;\n        padding: 20px;\n        overflow: auto;\n        background-color: #f9f9f9;\n\n        > .category {\n          height: 50px;\n          float: left;\n          cursor: pointer;\n          \n          ", " {\n            width: 20%;\n          }\n\n          ", " {\n            width: 25%;\n          }\n\n          ", " {\n            width: 50%;\n          }\n\n          &:hover {\n            > .category-name {\n              color: ", ";\n            }\n\n            > .underbar {\n              background-color: ", ";\n            }\n          }\n\n          > .category-name {\n            font-size: 14px;\n            height: 40px;\n            line-height: 40px;\n            color: ", ";\n            transition: color 0.4s;\n          }\n\n          > .underbar {\n            width: 15px;\n            height: 2px;\n            background-color: ", ";\n            transition: background-color 0.4s;\n          }\n        }\n\n        > .active {    \n          > .category-name {\n            color: ", " !important;\n          }\n        \n          > .underbar {\n            background-color: ", " !important;\n          }\n        }\n      }\n    }\n\n    > .board {\n      padding: 20px 0;\n      ", " {\n        min-height: 600px;\n      }\n    }\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PC, MEDIA_QUERIES.TABLET, MEDIA_QUERIES.PHONE, categoryHoverColor, categoryHoverColor, categoryColor, categoryColor, activeColor, activeColor, MEDIA_QUERIES.PC_TABLET);
var GET_PAGEBOARD = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query GetPageBoard ($id: String!) {\n    board(id: $id) {\n      id\n      name\n      type\n      categories\n      writableRole\n    }\n    currentUser {\n      id\n      role\n    }\n  }\n"], ["\n  query GetPageBoard ($id: String!) {\n    board(id: $id) {\n      id\n      name\n      type\n      categories\n      writableRole\n    }\n    currentUser {\n      id\n      role\n    }\n  }\n"])));
var PageBoard = /** @class */ (function (_super) {
    __extends(PageBoard, _super);
    function PageBoard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            category: ALL_CATEGORY,
            page: 1,
            pageCount: 1,
            currentId: null,
        };
        _this.updatePage = function (page) {
            _this.update({
                page: page,
                category: _this.state.category,
            });
        };
        _this.updateCategory = function (category) {
            _this.update({
                category: category,
                page: 1,
            });
        };
        _this.update = function (nextState) {
            var _a = _this.props, history = _a.history, location = _a.location;
            history.push({
                pathname: location.pathname,
                search: queryString.stringify({
                    category: nextState.category,
                    page: nextState.page,
                })
            });
            _this.setState(nextState);
        };
        _this.setCurrentId = function (id) {
            _this.setState({
                currentId: id,
            });
        };
        return _this;
    }
    PageBoard.prototype.componentDidMount = function () {
        var location = this.props.location;
        var nextState = this.state;
        if (location.search) {
            var _a = queryString.parse(location.search), category = _a.category, page = _a.page;
            if (category) {
                nextState.category = category;
            }
            if (page) {
                nextState.page = Number(page);
            }
        }
        this.update(nextState);
    };
    PageBoard.prototype.renderBoardByType = function (id, type, writable, currentId) {
        if (currentId === void 0) { currentId = null; }
        var TypedBoard = null;
        switch (type) {
            case BoardType.Board:
            default:
                TypedBoard = Board;
                break;
            case BoardType.Gallery:
                TypedBoard = Gallery;
                break;
        }
        return (React.createElement(TypedBoard, __assign({ id: id }, this.state, this.props, { updatePage: this.updatePage, currentId: currentId, writable: writable })));
    };
    PageBoard.prototype.renderPageBoard = function (categories, type, writable, currentId) {
        var _this = this;
        var id = this.props.id;
        return (React.createElement(React.Fragment, null,
            categories.length > 1 && (React.createElement("div", { className: "category-wrap" },
                React.createElement("div", { className: "categories" }, categories.map(function (category, idx) { return (React.createElement("div", { key: idx, className: cx('category', { active: category === _this.state.category }), onClick: function () { return _this.updateCategory(category); } },
                    React.createElement("div", { className: "category-name" }, category),
                    React.createElement("div", { className: "underbar" }))); })))),
            React.createElement("div", { className: "board" }, this.renderBoardByType(id, type, writable, currentId))));
    };
    PageBoard.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, match = _a.match;
        return (React.createElement(RootDiv, null,
            React.createElement(Query, { query: GET_PAGEBOARD, variables: { id: id }, fetchPolicy: "network-only" }, function (_a) {
                var loading = _a.loading, error = _a.error, data = _a.data;
                if (loading)
                    return React.createElement(Loading, null);
                if (error || !data.board)
                    return React.createElement(Error, { error: error });
                var _b = data.board, name = _b.name, categories = _b.categories, type = _b.type, writableRole = _b.writableRole;
                var role = data.currentUser && data.currentUser.role;
                var writable = role && writableRole >= role;
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "area" },
                        React.createElement("div", { className: "title" },
                            React.createElement(Title, { title: name })),
                        React.createElement(Switch, null,
                            React.createElement(Route, { path: match.url + "/write", render: function (props) {
                                    return React.createElement(PostWriter, { categories: categories, boardType: type, boardId: id, role: role });
                                } }),
                            React.createElement(Route, { path: match.url + "/:id/modify", render: function (props) {
                                    return React.createElement(PostModifier, __assign({ categories: categories, boardType: type, boardId: id, role: role }, props));
                                } }),
                            React.createElement(Route, { path: match.url + "/:id", render: function (props) {
                                    var currentId = Number(props.match.params.id);
                                    if (isClient && currentId !== _this.currentId) {
                                        window.scrollTo(0, 0);
                                    }
                                    _this.currentId = currentId;
                                    return (React.createElement(React.Fragment, null,
                                        React.createElement(Post, __assign({}, props, { boardId: id })),
                                        _this.renderPageBoard(categories, type, writable, currentId)));
                                } }),
                            React.createElement(Route, { exact: true, path: match.url, render: function (props) { return _this.renderPageBoard(categories, type, writable); } })))));
            })));
    };
    return PageBoard;
}(React.Component));
export default PageBoard;
var templateObject_1, templateObject_2;
